import React from 'react';
import MyAccountContentHeader from '../MyAccountContentHeader/MyAccountContentHeader';
import CopyToClipboard from '../../../../components/copyToClipboard/copyToClipboard';
import * as translator from '../../../../utils/translator';
import { PLAN_TYPE_LABEL } from './carePlusConstants';

interface CarePlusSubscriptionSummaryProps {
  subscription: CarePlusSubscriptionDetail['subscription'];
  language: string;
  orderHashId?: string;
}

const CarePlusSubscriptionSummary: React.FC<CarePlusSubscriptionSummaryProps> = ({ subscription, language, orderHashId }) => {
  const t = (path: string) => translator.translate(language, 'my_account', path);
  const planTypeLabel = subscription.isMonthlyPlan ? t('CarePlus/monthlyPlan/label') : PLAN_TYPE_LABEL[subscription.planType];
  const statusKeyMap: Record<string, string> = {
    active: 'CarePlus/detail/status',
    paused: 'CarePlus/detail/statusPaused',
    cancelled: 'CarePlus/detail/statusCancelled',
    pending: 'CarePlus/detail/statusPending',
  };
  const statusText = t(statusKeyMap[subscription.status] ?? statusKeyMap.active);

  return (
    <div className="careplus-order-detail__header">
      <MyAccountContentHeader
        title={orderHashId ?? subscription.hashId}
        titleFurnish={<CopyToClipboard textToCopy={orderHashId ?? subscription.hashId} />}
        description=""
        titleClass="careplus-order-detail__order-id"
      />
      <div className="careplus-order-detail__status-row">
        <span className="careplus-order-detail__status-badge">
          <span className="cp-status__state">{statusText}</span>
          <span className="cp-status__dot" />
          <span className="cp-status__plan">{t('CarePlus/detail/planPrefix')}<strong>{planTypeLabel.toUpperCase()}</strong></span>
        </span>
        <span className="careplus-order-detail__cycle-badge">
          <span className="cp-cycle__num">{subscription.currentCycleNumber}</span>
          {Number(subscription.billingCycles) > 0 && (
            <span className="cp-cycle__of">{t('CarePlus/detail/of')} {subscription.billingCycles}</span>
          )}
          <span className="cp-cycle__label">{t('CarePlus/detail/deliveryCycle')}</span>
        </span>
      </div>
    </div>
  );
};

export default CarePlusSubscriptionSummary;
